import { Box, Container, Typography, Link as MuiLink } from '@mui/material'

export const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <Box
      component="footer"
      sx={{
        backgroundImage: 'linear-gradient(90deg, #430397, #fe2f61)',
        py: 4,
        mt: 'auto',
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
          }}
        >
          {/* Links */}
          <Box
            sx={{
              display: 'flex',
              gap: { xs: 2, sm: 3 },
              flexWrap: 'wrap',
              justifyContent: 'center',
              mb: 1,
            }}
          >
            <MuiLink
              href="https://www.nbcuniversalprivacy.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: '#fff',
                textDecoration: 'none',
                fontSize: { xs: '0.85rem', md: '0.875rem' },
                fontWeight: 500,
                transition: 'opacity 0.2s ease',
                '&:hover': {
                  opacity: 0.8,
                  textDecoration: 'underline',
                },
              }}
            >
              Privacy Policy
            </MuiLink>
            <Box
              component="span"
              sx={{
                color: '#fff',
                opacity: 0.6,
                display: { xs: 'none', sm: 'inline' },
              }}
            >
              |
            </Box>
            <MuiLink
              href="https://www.nbcuniversal.com/terms"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: '#fff',
                textDecoration: 'none',
                fontSize: { xs: '0.85rem', md: '0.875rem' },
                fontWeight: 500,
                transition: 'opacity 0.2s ease',
                '&:hover': {
                  opacity: 0.8,
                  textDecoration: 'underline',
                },
              }}
            >
              Terms of Service
            </MuiLink>
            <Box
              component="span"
              sx={{
                color: '#fff',
                opacity: 0.6,
                display: { xs: 'none', sm: 'inline' },
              }}
            >
              |
            </Box>
            <MuiLink
              href="https://www.nbcuniversalprivacy.com/privacy/cookies#accordionheader2"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: '#fff',
                textDecoration: 'none',
                fontSize: { xs: '0.85rem', md: '0.875rem' },
                fontWeight: 500,
                transition: 'opacity 0.2s ease',
                '&:hover': {
                  opacity: 0.8,
                  textDecoration: 'underline',
                },
              }}
            >
              Ad Choices
            </MuiLink>
            <Box
              component="span"
              sx={{
                color: '#fff',
                opacity: 0.6,
                display: { xs: 'none', sm: 'inline' },
              }}
            >
              |
            </Box>
            <MuiLink
              href="https://www.nbcuniversalprivacy.com/privacy/cookies"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: '#fff',
                textDecoration: 'none',
                fontSize: { xs: '0.85rem', md: '0.875rem' },
                fontWeight: 500,
                transition: 'opacity 0.2s ease',
                '&:hover': {
                  opacity: 0.8,
                  textDecoration: 'underline',
                },
              }}
            >
              Cookie Notice
            </MuiLink>
          </Box>

          {/* Copyright */}
          <Typography
            variant="body2"
            align="center"
            sx={{
              color: '#fff',
              fontSize: { xs: '0.85rem', md: '0.875rem' },
              letterSpacing: '0.01em',
            }}
          >
            © {currentYear} NBC Universal Global Networks España S.L.U. All
            rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  )
}
